export default "__VITE_ASSET__De9qJ_rk__"